import create from './http';
const CONFIG = {
  dev: '//qa-outsight.inuozhen.com/', //qa-outsight.inuozhen.com/
  qa: '//pre-outsight.inuozhen.com/', //qa-outsight.inuozhen.com/
  pre: '//pre-outsight.inuozhen.com/',
  prod: '//outsight.inuozhen.com/'
};
const env = process.env.VUE_APP_ENV;
const baseURL = CONFIG[env];
const service = create({ baseURL });
service.__custom__config__ = CONFIG;
service.changeBaseURL = function(newEnv) {
  if (env === 'prod') {
    return;
  }
  if (newEnv && CONFIG[newEnv]) {
    console.log('!!!注意！！！：你修改了请求的baseURL');
    service.defaults.baseURL = CONFIG[newEnv];
  }
};
export default service;
